import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MeineDatenComponent } from '../meinedaten.component';
import { AuthService } from '../../../../../services.module/auth.service';
import { ActivatedRoute } from '@angular/router';
import { AppConstants } from '../../../../../app-constants.service';
import { ConfirmationObservable, MessageObservable } from '../../../../../services.module/message.observable';
import { ConfigurationApiService } from '../../../../../../generated/api/configuration/configuration.service';
import { UserService } from '../../../../../providers.module/user.service';
import { UserApiService } from '../../../../../../generated/api/user/user.service';
import { PartnerProfilData } from '../../../../../../generated/api/kreditportalBackendAPI.schemas';

@Component({
    selector: 'kunden-basisdaten',
    templateUrl: './kd-basisdaten.component.html',
    styleUrls: ['../../../../commonless/content.less', '../../../../commonless/meine-daten.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KundenBasisdatenComponent extends MeineDatenComponent {

    @Input()
    partnerModel: PartnerProfilData = null;

    constructor(
        protected override readonly authService: AuthService,
        protected override readonly route: ActivatedRoute,
        protected override readonly appConstants: AppConstants,
        protected override readonly confirmationHandler: ConfirmationObservable,
        protected override readonly messageHandler: MessageObservable,
        protected override readonly configurationApiService: ConfigurationApiService,
        protected override readonly userApiService: UserApiService,
        protected override readonly userService: UserService
    ) {
        super(
            authService,
            route,
            appConstants,
            confirmationHandler,
            messageHandler,
            configurationApiService,
            userApiService,
            userService
        );
    }

}
